// @ts-strict-ignore
import React from 'react'
import { useSelector } from 'APP/Hooks/redux'
import styled from 'styled-components/native'
import { Trans } from 'react-i18next'
import { SafeAreaView } from 'react-native-safe-area-context'
import { NativeStackScreenProps } from '@react-navigation/native-stack'

import { Images } from 'APP/Themes'
import Config from 'APP/Config'
import I18n from 'APP/I18n'
import { getBrandConfig } from 'APP/Lib/ConfigHelpers'
import { openInbox } from 'APP/Lib/EmailLinking'
import { handlePressContactSupport } from 'APP/Helpers/handlePressContactSupport'
import Typography from 'APP/Converse/Typography'
import { ResponsiveView } from 'APP/Converse/Layout'
import Button from 'APP/Converse/Button'
import ChallengedInvitationFooter from 'APP/Components/ChallengedInvitationFooter'
import LogoHeader from 'APP/Components/LogoHeader'

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

export type CheckEmailScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'checkEmail'
>

const CheckEmailScreen = ({ route }: CheckEmailScreenProps) => {
  const { email } = route.params

  const { challengedInvitationQueue } = useSelector((state) => state.patient)

  const isInChallengedQueue = (challengedInvitationQueue ?? []).length > 0

  const { productName } = getBrandConfig(Config.BRAND_ID, I18n.locale)

  const subtitle = (
    <Typography>
      {
        <Trans i18n={I18n} i18nKey="CheckEmailScreen.subtitle" values={{ productName, email }}>
          <Typography variant="subheaderBold">{{ productName }}</Typography>
          <Typography variant="subheaderBold">{{ email }}</Typography>
        </Trans>
      }
    </Typography>
  )

  return (
    <ScreenContainer>
      <ContentContainer>
        <LogoHeader
          source={Images.logoBlue}
          title={I18n.t('CheckEmailScreen.title')}
          subtitle={subtitle}
        />
        <Button
          variant="primary"
          widthVariant="full"
          title={I18n.t('CheckEmailScreen.openEmailButton')}
          analyticsName={'CheckEmailScreen.openEmailApp'}
          onPress={openInbox}
        />
        <Button
          variant="tertiary"
          widthVariant="full"
          title={I18n.t('Common.contactSupport')}
          analyticsName={'Common.contactSupport'}
          onPress={handlePressContactSupport}
          testID="CONTACT_SUPPORT_BTN"
        />
        {isInChallengedQueue ? <ChallengedInvitationFooter /> : null}
      </ContentContainer>
    </ScreenContainer>
  )
}

export default CheckEmailScreen
